export const GET_USER = "/users/:id"

export const SEARCH_USERS = "/users"

export const LIST_USERS = "/users/list"

export const GET_LIST_OPTIONS = "/users/options"

export const CREATE_USER = "/users"

export const GET_ME = "/users/me"

export const GET_PROFILE = "/users/profile/:id"

export const CREATE_MULTIPLE_USERS = "/users/many"

export const RESET_PASSWORD = "/password/:id/reset"

export const UPDATE_USER = "/users/:id/update"

export const REMOVE_SER = "/users/:id/delete"

export const GET_ROLES = "/roles"

export const FIND_ROLE_BY_NAME = "/roles/name/:name"

export const FIND_ROLE_BY_ID = "/roles/:id"

export const DELETE_ROLE = "/roles/:id/delete"

export const UPDATE_ROLE = "/roles/:id/update"

export const GET_PERMISSIONS = "/permissions"

export const GET_ACTIONS_LIST = "/users/actions"

export const RESET_2FA = "/users/admin/reset-mfa/:id"

export const POST_PING_ME = "/users/ping"
